import { Image, Typography } from "antd";
import { useTranslation } from "react-i18next";
import I18Provider from "../../i18n/I18Provider";
import uxloader from "../../assets/images/uxloader.gif";

export default function UXloader({ lang = "en", heightClass = "h-100vh" }) {
  const { t } = useTranslation();

  return (
    <I18Provider lang={lang}>
      <div className={`${heightClass} flex-item flex-center flex-column bg-white`}>
        <Image src={uxloader} style={{ width: 80 }} preview={false} />
        <Typography.Paragraph className='m-0'>{t("loading")}</Typography.Paragraph>
      </div>
    </I18Provider>
  );
}
